import { combineReducers, configureStore } from '@reduxjs/toolkit'
import app from './app'
import account from './account'
import banners from './banners'
import categories from './categories'
import markets from './markets'
import wagers from './wagers'
import wallet from './wallet'
import users from './users'
import search from './search'
import notifications from './notifications'
import tags from './tags'
import comments from './comments'
import feedback from './feedback'

const rootReducer = combineReducers({
  app,
  account,
  banners,
  categories,
  markets,
  wagers,
  wallet,
  users,
  search,
  tags,
  notifications,
  comments,
  feedback,
})

/**
 * Create a new store instance. Use this for SSR (one store per request) and for
 * client hydration when preloadedState is provided.
 * @param {object} [preloadedState] - Optional initial state (e.g. from server).
 */
export function makeStore(preloadedState) {
  return configureStore({
    devTools: true,
    reducer: rootReducer,
    ...(preloadedState != null && { preloadedState }),
  })
}

const store = makeStore()
export default store
